import { FontWeight, Text } from '@lili/lili-frontend-common';
import { Trans, useTranslation } from 'react-i18next';
import { ReactComponent as TrustpilotStarIcon } from '@Assets/dnbEmbeddedIntro/trustpilot-star.svg';
import { ReactComponent as FdicShieldIcon } from '@Assets/dnbEmbeddedIntro/fdic-shield-outline.svg';
import trustpilotMicroUrl from '@Assets/banners/trustpilot.svg';

const Spacer = () => (
  <div className='flex flex-1 items-center justify-center max-w-[56px] p-2'>
    <div className='w-px h-[36px] bg-outline-primary-bw-05 opacity-50' />
  </div>
);

interface DnbTrustRowProps {
  variant?: 'desktop' | 'mobile';
}

export const DnbTrustRow = ({ variant = 'desktop' }: DnbTrustRowProps) => {
  const { t } = useTranslation();

  return (
    <div className='flex items-center justify-center w-full'>
      {variant === 'desktop' ? (
        <div className='flex flex-col gap-[4px] w-[80px]'>
          <div className='flex gap-[1px]'>
            {Array.from({ length: 5 }).map((_, index) => (
              <TrustpilotStarIcon key={index} className='size-[15px]' />
            ))}
          </div>
          <div className='flex gap-[4px] items-center text-text-main-primary'>
            <Text.H14 fontWeight={FontWeight.SEMIBOLD}>
              {t('pages.dnbEmbeddedIntro.trustpilotRatingValue')}
            </Text.H14>
            <Text.H14>{t('pages.dnbEmbeddedIntro.trustpilotRatingLabel')}</Text.H14>
          </div>
        </div>
      ) : (
        <img
          src={trustpilotMicroUrl}
          alt={t('pages.dnbEmbeddedIntro.trustpilotRatingLabel')}
          className='h-[20px] w-auto shrink-0'
        />
      )}
      <Spacer />
      <div className='flex items-center gap-[8px] shrink-0'>
        {variant === 'desktop' && (
          <div className='flex items-center justify-center size-[28px] rounded-full bg-surface-brand-action-03 shrink-0'>
            <FdicShieldIcon className='size-[18.667px]' />
          </div>
        )}
        <Text.H12 fontWeight={FontWeight.SEMIBOLD} className='text-text-main-primary'>
          <Trans i18nKey='pages.dnbEmbeddedIntro.fdicLabel' components={{ sup: <sup /> }} />
        </Text.H12>
      </div>
      <Spacer />
      <div className='flex flex-col w-[109px] shrink-0 text-text-main-primary'>
        <Text.H12 fontWeight={FontWeight.SEMIBOLD}>
          {t('pages.dnbEmbeddedIntro.businessesServedCount')}
        </Text.H12>
        <Text.H12>{t('pages.dnbEmbeddedIntro.businessesServedLabel')}</Text.H12>
      </div>
    </div>
  );
};

export default DnbTrustRow;
